import styled from 'styled-components';
import {GameJackpotBarLogoDefaultBox} from './game-jackpot-bar-logo.default.box';

export const GameJackpotBarLogoCasino777Box = styled(GameJackpotBarLogoDefaultBox)<{isOptInStatus?: boolean}>`
    background-size: ${({isMobilePortrait}) => isMobilePortrait ? '65%' : '60%'};
    background-position-y: ${({isMobilePortrait}) => isMobilePortrait ? '50%' : '52%'};

    @media ${({theme}) => theme.mediaQuery.xxl} {
      background-size: 55%;
    }
`;